export function customElement<T extends string>(tagname: T) {
  return (target: CustomElementConstructor): void => {
    if (customElements.get(tagname)) {
      return;
    }
    customElements.define(tagname, target);
  };
}
